module.exports = __webpack_public_path__ + "static/img/070_TO8_1689_og.be8befc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/070_TO8_1689_og.jpg
// module id = R0Xt
// module chunks = 0